import React, { Component } from "react";
import { connect } from "react-redux";
import cx from "classnames";
//
import Screen from "./ConnectedScreen";

class VerifyEmailOtpScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      error: false,
      otp: null,
    };
  }

  enterSubmit(ev) {
    if (ev.key === "Enter") {
      this.onSubmit();
    }
  }

  onSubmit() {
    const { otp } = this.state;
    const { verifyBooking } = this.props;

    if (otp && otp.length === 4) {
      verifyBooking(otp);
    } else {
      this.setState({
        error: true,
      });
    }
  }

  onOtpChange(otp) {
    this.setState({
      otp,
      error: false,
    });
  }

  render() {
    const { errorMessage, email } = this.props;
    const { otp, seconds, error } = this.state;

    return (
      <Screen
        title="Enter OTP code"
        isActive
        className="screen--otp form"
        nextLabel="Verify OTP"
        onBack={false}
        onNext={(ev) => this.onSubmit()}
      >
        <p className="u-mb-large">
          We have sent a 4-digit OTP code to{" "}
          <span className="u-brand">{email}</span>, please enter the code below.
        </p>
        <div className={cx("form__field", { error })}>
          <label>Enter OTP</label>
          <input
            type="number"
            name="otp"
            value={otp || ""}
            className="form__control"
            placeholder="e.g: 1234"
            onChange={(ev) => this.onOtpChange(ev.target.value)}
            autoFocus
            onKeyDown={(ev) => this.enterSubmit(ev)}
          />
          {error && (
            <small className="form__error">OTP code must be 4-digit long</small>
          )}
        </div>
        {errorMessage !== null && (
          <p className="u-danger u-small u-mv">{errorMessage}</p>
        )}
        <div className="content alert alert--premium u-mt-large">
          <h5 className="u-mb-small">Not receiving OTP?</h5>
          <ul>
            <li>It can <strong>take up to 5 minutes</strong> to receive the code on your email client</li>
            <li>Please also do <strong>check your spam/junk box</strong> for the otp code</li>
            <li>Alternatively verify your booking <strong>by emailing</strong> <a href="mailto:verify@smooci.com">verify@smooci.com</a></li>
            <li>Or email <a href="mailto:contact@smooci.com">contact@smooci.com</a> for more help</li>
          </ul>
        </div>
      </Screen>
    );
  }
}

// @connect
import { verifyBookingAction } from "../modules/booking/actions";

function mapState(state) {
  const { booking } = state;

  return {
    email: booking.email,
  };
}

function mapDispatch(dispatch) {
  return {
    verifyBooking(otp) {
      dispatch(verifyBookingAction(otp));
    },
  };
}

export default connect(
  mapState,
  mapDispatch
)(VerifyEmailOtpScreen);
